import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'is_IS',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '22d45135-84a9-42ae-8e11-08d6b8ca79e7',
  ''
);
